import { type ReactNode, type RefObject } from 'react';

const ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen';
const IFRAME_CLS = 'aspect-video w-full rounded-lg';

function buildYTSrc(videoId: string): string {
  const origin = encodeURIComponent(window.location.origin);
  const params = [
    'enablejsapi=1',
    `origin=${origin}`,
    'rel=0',
    'playsinline=1',
    'modestbranding=1',
    'iv_load_policy=3',
  ].join('&');
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params}`;
}

const LOOM_HIDE =
  'hideEmbedTopBar=true&hide_owner=true&hide_share=true&hide_title=true&hide_speed=true';

function buildLoomSrc(videoId: string, hideUi: boolean): string {
  const base = `https://www.loom.com/embed/${videoId}`;
  return hideUi ? `${base}?${LOOM_HIDE}` : base;
}

type YTProps = {
  videoId: string;
  innerRef: RefObject<HTMLIFrameElement | null>;
};

export function YTIframe({ videoId, innerRef }: YTProps): ReactNode {
  return (
    <iframe
      ref={innerRef}
      className={IFRAME_CLS}
      src={buildYTSrc(videoId)}
      allow={ALLOW}
      allowFullScreen
      title="Video"
    />
  );
}

type LoomProps = {
  videoId: string;
  innerRef: RefObject<HTMLIFrameElement | null>;
  hideUi?: boolean;
};

export function LoomIframe({
  videoId,
  innerRef,
  hideUi = true,
}: LoomProps): ReactNode {
  return (
    <iframe
      ref={innerRef}
      className={IFRAME_CLS}
      src={buildLoomSrc(videoId, hideUi)}
      allow={ALLOW}
      allowFullScreen
      title="Video"
    />
  );
}
